export const SIDEBAR_WIDTH = '277px';
export const CONTENT_WIDTH = '1250px';
export const OFFCANVAS_MENU_BP = '1024px';
export const MOBILE_BP = '767px';
export const TABLET_BP = '1024px';
